import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_NAV_ITEM } from '../../../sites/aflm/store/js/modules/statspro/stats-leaders/actions';

/**
 * @param {object} arg
 * @param {object} arg.competition
 * @param {object} arg.competition.id
 * @param {object} arg.season
 * @param {number|null} arg.season.id
 * @param {object} arg.round
 * @param {number|null} arg.round.id
 * @param {number|null} arg.round.number
 * @returns {{ 
 *    competitions: object,
 *    seasons: object,
 *    rounds: object
 * }}
 */
export const useCompetitionNavigationOptions = ( { competition, season, round } ) => {
    const dispatch = useDispatch();
    
    // @ts-ignore
    const competitionList = useSelector( state => state.competitions.list );
    // @ts-ignore
    const seasonList = useSelector( state => state.seasons[ `competition_${competition.id}` ]?.list );
    // @ts-ignore
    const roundList = useSelector( state => state.rounds[ `season_${season.id}` ]?.list );

    /**
     * Fetch competition data if missing.
     */
    useEffect( () => {
        if ( !competitionList ) {
            dispatch(
                // @ts-expect-error
                window.PULSE.app.redux.actions.competitions
                    .API__FETCH_COMPETITIONS
                    .request()
            );
        }
    }, [] );

    /**
     * Fetch season data if missing.
     */
    useEffect( () => {
        if ( competitionList && competition.id && !seasonList ) {
            dispatch(
                // @ts-expect-error
                window.PULSE.app.redux.actions.seasons
                    .API__FETCH_SEASONS
                    .request( competition.id )
            );
        }
    }, [ competitionList, competition, seasonList ] );
    
    /**
     * Fetch round data if missing.
     */
    useEffect( () => {
        if ( seasonList && season.id && !roundList ) {
            dispatch(
                // @ts-expect-error
                window.PULSE.app.redux.actions.rounds
                    .API__FETCH_ROUNDS
                    .request( season.id )
            );
        }
    }, [ seasonList, season, roundList ] );

    /**
     * Ensure stats leaders nav data is correct.
     */
    useEffect( () => {
        if ( competitionList && !competition.id ) {
            // @ts-expect-error
            const { PREMIERSHIP } = PULSE.app.common.CONSTANTS.PROVIDER_IDS;
            const aflPremiershipCompetition = competitionList.find(
                comp => comp.providerId === PREMIERSHIP
            );

            if ( aflPremiershipCompetition ) {
                dispatch(
                    UPDATE_NAV_ITEM.request( {
                        navItem: 'competition',
                        value: { id: aflPremiershipCompetition.id }
                    } )
                );
            }
        }

        if ( seasonList && !season.id ) {
            dispatch(
                UPDATE_NAV_ITEM.request( {
                    navItem: 'season',
                    value: { id: seasonList[ 0 ].id }
                } )
            );
        }

        if ( roundList && round.id === null )  {
            dispatch(
                UPDATE_NAV_ITEM.request( {
                    navItem: 'round',
                    value: {
                        id: -1,
                        number: 0
                    }
                } )
            );
        }
    }, [ competitionList, seasonList, roundList ] );

    useEffect( () => {
        if ( !roundList || !seasonList || round.id === null || round.id === -1 ) { return; }

        if ( !roundList.find( r => r.id === round.id ) ) {
            const targetRound = roundList.find(
                r => r.roundNumber === round.number
            ) ?? roundList[ 0 ];
            
            dispatch(
                UPDATE_NAV_ITEM.request( {
                    navItem: 'round',
                    value: {
                        id: targetRound.id,
                        number: targetRound.roundNumber
                    }
                } )
            );
        }
    }, [ round, roundList, seasonList ] );

    return {
        competitions: competitionList,
        seasons: seasonList,
        rounds: roundList ? [
            { id: -1, name: 'Entire Season', roundNumber: 0 },
            ...roundList
        ] : null
    };
};